module.exports = "/wwwroot/img/mobile-navi-drops.svg?ver=7b2323fd";